export enum AppName {
  dynamic_pricing = 'Dynamic Pricing',
}

export enum AppRoutes {
  BLANK_SPACE = '',
  CREATE = 'create',
  CUSTOMER_EXCLUDE = 'customer-exclude',
  DASHBOARD = 'dashboard',
  DETAIL_PAGE = 'detail-page',
  DYNAMIC_PRICING = 'dynamic-pricing',
  DYNAMIC_RULE = 'dynamic-rule',
  LIST_PAGE = 'list-page',
  NOT_AUTHORIZED_PAGE = 'not-authorized',
  RATE_QUOTE = 'rate-quote',
  RESULT_PAGE = 'result',
  ROOT = '/',
  SHIPMENT_VISIBILITY = 'shipment-visibility',
  UPDATE_PRICING_RULE = 'update-pricing-rule',
  PRICING_RULE = 'pricing-rule',
  ACCESSORIAL_CHARGE = 'accessorial-charge',
  ABSOLUTE_MINIMUM_CHARGE = 'absolute-minimum-charge',
  CUSTOMER_GROUP = 'customer-group',
  CREATE_DPT_RULE = 'create-dpt-rule',
  RFP = 'rfp',
  PRICING_CODES = 'pricing-codes',
  DPT_DISCOUNT = 'dpt-discount',
}

export enum AppRouteLabels {
  rfp = 'RFP',
  dynamicRules = 'Dynamic Rules',
  customers = 'Customers',
  customerGroups = 'Customer Groups',
  testHarness = 'Test Harness',
  shipmentVisibility = 'Shipment Visibility',
  admin = 'Admin',
  amc = 'Absolute Minimum Charges',
  ac = 'Accessorial Charges',
  dptDiscount = 'DPT Discount',
  pricingCodes = 'Pricing Codes',
  dashboard = 'Dashboard',
}
